import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, CSSObject, styled, Tooltip } from "@mui/material";
import React from "react";

const COMMON_CELL_STYLE: CSSObject = {
  textTransform: "uppercase",
  padding: "0px",
  paddingLeft: "4px",
  paddingRight: "4px",
  fontSize: "16px",
  textAlign: "center",
  border: "none",
  minWidth: "60px",
};

const BaseTableCell = styled(Box)(() => ({
  ...COMMON_CELL_STYLE,
}));

export const StyledHeadTableCell = styled(BaseTableCell)(() => ({
  fontSize: "16px",
}));

export const StyledTableCell = styled(BaseTableCell)(() => ({
  fontSize: "24px",
}));

const BaseDivCell = styled("div")(() => ({
  ...COMMON_CELL_STYLE,
}));

export const StyledHeadDivCell = styled(BaseDivCell)(() => ({
  fontSize: "14px",
  display: "flex",
  justifyContent: "center",
  height: "100%",
  alignItems: "center",
}));

export const StyledDivCell = styled(BaseDivCell)(() => ({
  fontSize: "24px",
  alignSelf: "center",
}));


// Define UnclearHeaderComponent outside of the main component
export function UnclearHeaderComponent({
  showBottomBorder,
  onTooltipClick,
}: {
  showBottomBorder: boolean;
  onTooltipClick: () => void;
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      UNCLEAR
      {showBottomBorder && (
        <Tooltip title="Click for unclear details" onClick={onTooltipClick}>
          <InfoOutlinedIcon className="cursor-pointer ml-2" fontSize="small" />
        </Tooltip>
      )}
    </Box>
  );
}

export function detectorMetricsStyle(showBottomBorder: boolean) {
  return {
    // Root styles
    border: "none",

    // Cell styles
    "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
      border: "none",
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textTransform: "uppercase",
    },

    // Column header styles
    "& .MuiDataGrid-columnHeader": {
      fontSize: "14px",
    },

    // Column header title container styles
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      justifyContent: "center",
      alignItems: "center",
    },

    // Column separator styles
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },

    // Column header title styles
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    "& .MuiDataGrid-row.Mui-hovered": {
      backgroundColor: "transparent",
    },

    // Add border bottom to all rows
    "& .MuiDataGrid-row .MuiDataGrid-cell": {
      borderBottom: "1px solid #E5E9ED",
    },

    // Virtual scroller styles
    "& .MuiDataGrid-virtualScroller": {
      marginTop: "30px!important",
      marginBottom: "5px!important",
      overflowX: "auto!important",
      paddingBottom: "5px",
      "&::-webkit-scrollbar": {
        width: "6px",
        height: "10px",
        direction: "ltr",
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#C8CDD3",
        borderRadius: "10.32px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#919599",
      },
    },

    // Pinned columns (left/right)
    "& .MuiDataGrid-pinnedColumnHeaders--left, & .MuiDataGrid-pinnedColumns--left, .MuiDataGrid-pinnedColumnHeaders--right, & .MuiDataGrid-pinnedColumns--right": {
      boxShadow: "none",
      backgroundColor: "#f2f5f6!important",
      zIndex: 2,
    },

    "& .MuiDataGrid-pinnedColumnHeaders--left, & .MuiDataGrid-pinnedColumns--left": {
      borderRight: "1px solid #E5E9ED",
    },

    "& .MuiDataGrid-pinnedColumnHeaders--right, & .MuiDataGrid-pinnedColumns--right": {
      borderInlineStart: "1px solid #E5E9ED",
    },

    // Remove focus outlines
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
      outline: "none !important",
    },

    // Hide bottom border when showBottomBorder is false
    ...(showBottomBorder
      ? {
        // Bold + border: last and third-last row
        "& .MuiDataGrid-row:nth-last-of-type(1) .MuiDataGrid-cell, .MuiDataGrid-row:nth-last-of-type(3) .MuiDataGrid-cell": {
          borderBottom: "2px solid #6b7280",
          fontWeight: 700,
        },
      }
      : {
        "& .MuiDataGrid-row:last-child .MuiDataGrid-cell": {
          borderBottom: "none",
          fontWeight: 700,
        },
      }),

    // Faded text: penultimate row
    "& .MuiDataGrid-row:nth-last-of-type(2) .MuiDataGrid-cell": {
      color: "#A3A3A3",
    },

    // Optional class override
    "& .text-primary-dark": {
      color: "#0450BA!important",
    },
  }
}